import { render, staticRenderFns } from "./no-quotes-reason.vue?vue&type=template&id=32f7a5d8&scoped=true&lang=pug&"
import script from "./no-quotes-reason.vue?vue&type=script&lang=js&"
export * from "./no-quotes-reason.vue?vue&type=script&lang=js&"
import style0 from "./no-quotes-reason.vue?vue&type=style&index=0&id=32f7a5d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f7a5d8",
  null
  
)

/* custom blocks */
import block0 from "./no-quotes-reason.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports